import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";
export default function AAMCAPPFeatures() {
  const benefits = [
    {
      img: img2,
      title: "Real-time Asset Monitoring and Tracking",
      bodycopy:
        "Users can easily monitor and track their agricultural assets (crops, livestock, equipment) and farms in real-time, enabling better management and resource optimization.",
    },
    {
      img: img3,
      title: "Quality Assurance for Agri Assets and Farms",
      bodycopy:
        "The app ensures that all assets and farms are verified for quality, providing detailed information to help users maintain high standards for their agricultural operations."
    },
    {
      img: img1,
      title: "Automated Monthly Invoicing",
      bodycopy:
      "The app generates monthly invoices for all agri assets, making the billing process straightforward and reducing manual accounting tasks."
    },

    {
      img: img1,
      title: "Verified Assets Delivery",
      bodycopy:
      "Only assets that have undergone verification are delivered, ensuring that users receive trustworthy and reliable products or services."
    },
    {
      img: img1,
      title: "Centralized Farm and Asset Data",
      bodycopy:
      "All data related to farms and assets are stored and accessible in one place, allowing users to view, manage, and analyze information seamlessly."
    },

    {
      img: img1,
      title: "Customizable Notifications and Alerts",
      bodycopy:
      "Users can set up alerts for asset tracking updates, quality checks, invoice generation, or other key activities, ensuring timely management."
    },


    {
        img: img1,
        title: "User-Friendly Interface",
        bodycopy:
"The app provides an intuitive, easy-to-use interface that allows users of any experience level to navigate and use its features effectively."      },
  
      {
        img: img1,
        title: "Analytics and Reporting Tools",
        bodycopy:
        "Detailed reports and insights on asset performance, farm productivity, and financial data are available to help users make informed decisions."      },

      {
        img: img1,
        title: "Data Security and Compliance",
        bodycopy:
        "The app ensures that all farm and asset data are securely stored and managed in compliance with relevant agricultural and data protection regulations."
      },

      {
        img: img1,
        title: "Multi-Platform Access",
        bodycopy:
        "Users can access the app on multiple platforms, such as mobile devices and desktop computers, ensuring flexibility and ease of use in different working environments."
      },
  ];
  return (
    <div className="main-wrapper">
      <Container className="subSectionWrapper ">
        <h2 className="text-center container-title mb-4">Features</h2>
        <Row>
          {benefits.map((e,index) => {
            return (
              <Col md={4} key={index} className="d-flex">
                <BenefitsCard
                  src={e.img}
                  title={e.title}
                  bodycopy={e.bodycopy}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}
